module.exports = __webpack_public_path__ + "static/media/vts5.b9b92703.jpg";